import { render } from "./UploadAudios.vue?vue&type=template&id=617a0ddc&scoped=true&ts=true"
import script from "./UploadAudios.vue?vue&type=script&lang=ts"
export * from "./UploadAudios.vue?vue&type=script&lang=ts"

import "./UploadAudios.vue?vue&type=style&index=0&id=617a0ddc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617a0ddc"]])

export default __exports__